import { getBalance } from '../../cred';
import { balanceCoins } from '../../params';

export const initialWalletBal = {
	avble: 0,
	schd: 0,
};
// export const initialRefWallet = {
// 	inr: {
// 		avble: 0,
// 		schd: 0,
// 	},
// 	usdt: {
// 		avble: 0,
// 		schd: 0,
// 	},
// };

let initialCryptoBalStart = {};

balanceCoins.forEach(coin => {
	initialCryptoBalStart = {
		...initialCryptoBalStart,
		[coin]: {
			val: 0,
			orders: 0,
			convRate: 0,
		},
	};
});

export const initialCryptoBal = initialCryptoBalStart;

const checkNegatives = (walletBal, cryptoBal) => {
	const inrCheck = walletBal.avble >= -1 && walletBal.schd >= -1;

	return Object.keys(cryptoBal).reduce((tot, key) => {
		if (typeof cryptoBal[key].val !== 'undefined') {
			return cryptoBal[key].val >= 0 && cryptoBal[key].orders >= 0 && tot;
		}
		return tot;
	}, inrCheck);
};

const getBalances = async ({ lastBalChecked }, forced) => {
	if (
		lastBalChecked === null ||
		new Date() - lastBalChecked > 2000 ||
		forced === true
	) {
		try {
			const resp = await getBalance();

			if (resp.status === 1) {
				const balances = resp.data;
				const walletBal = {
					avble: balances.playMoney || 0,
					schd: balances.inoMoney || 0,
				};
				const cryptoBal = {};

				balanceCoins.forEach(coin => {
					const coinUpper = coin.toUpperCase();

					switch (coin) {
						case 'stmx':
							cryptoBal.stmx = {
								val: balances.playSTORM || 0,
								orders: balances.inoSTORM || 0,
								convRate: balances.convRatioSTORM || 0,
							};
							break;
						case 'pundix':
							cryptoBal.pundix = {
								val: balances.playNPXS || 0,
								orders: balances.inoNPXS || 0,
								convRate: balances.convRatioNPXS || 0,
							};
							break;
						case 'glm':
							cryptoBal.glm = {
								val: balances.playGNT || 0,
								orders: balances.inoGNT || 0,
								convRate: balances.convRatioGNT || 0,
							};
							break;
						case 'ram':
							cryptoBal.ram = {
								val: balances.playRAM || 0,
								orders: balances.inoRAM || 0,
								convRate: balances.convRatioRAM || 0,
								convRateRAMEOS: balances.convRatioRAMEOS || 0,
							};
							break;
						case 'phb':
							cryptoBal.phb = {
								val: balances.playRPX || 0,
								orders: balances.inoRPX || 0,
								convRate: balances.convRatioRPX || 0,
							};
							break;
						case 'vet':
							cryptoBal.vet = {
								val: balances.playVEN || 0,
								orders: balances.inoVEN || 0,
								convRate: balances.convRatioVEN || 0,
							};
							break;
						default:
							cryptoBal[coin] = {
								val: balances[`play${coinUpper}`] || 0,
								orders: balances[`ino${coinUpper}`] || 0,
								convRate:
									balances[`convRatio${coinUpper}`] || 0,
							};
					}
				});

				const isNotFlagged = checkNegatives(walletBal, cryptoBal);

				return {
					cryptoBal,
					// refWallet: {
					// 	inr: {
					// 		avble: balances.playFEE || 0,
					// 		schd: balances.inoFEE || 0,
					// 	},
					// 	usdt: {
					// 		avble: balances.playUFEE || 0,
					// 		schd: balances.inoUFEE || 0,
					// 	},
					// },
					kaatLe: balances.kaatLe,
					isNotFlagged,
					walletBal,
					lastBalChecked: Date.now(),
				};
			}
		} catch (error) {
			console.log('balances', error);
		}
	}

	return {};
};

// ------------------------------------------------------

export const balanceActions = {
	/**
	 * Balances:
	 */
	__checkBalances: getBalances,
	__resetBalances: () => ({
		cryptoBal: initialCryptoBal,
		// refWallet: initialRefWallet,
		kaatLe: 1,
		walletBal: initialWalletBal,
		isNotFlagged: true,
		lastBalChecked: null,
	}),
};
